import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, EMPTY, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface HashtagSuggestion {
  tag:        string;   // normalised: lowercase, no #, e.g. "london"
  usageCount: number;
}

@Injectable({ providedIn: 'root' })
export class HashtagService {

  private http       = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl    = `${environment.apiUrl}/hashtags`;

  /**
   * Fetches hashtag suggestions for a given prefix.
   *
   * searchHashtags('lon')   → [{ tag: 'london', usageCount: 42 }, …]
   * searchHashtags('')      → top trending tags
   */
  searchHashtags(prefix: string, limit = 8): Observable<HashtagSuggestion[]> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;

    const params = new HttpParams()
      .set('q', prefix.replace(/^#+/, '').toLowerCase())
      .set('limit', String(limit));

    return this.http
      .get<{ data: HashtagSuggestion[] }>(`${this.baseUrl}/autocomplete`, { params })
      .pipe(
        map(res => res.data ?? []),
        catchError(() => of([])),
      );
  }
}